export default function CrossSection({ product, ghost = false }) {
  return (
    <svg
      viewBox="0 0 120 120"
      className="cs-svg"
      aria-hidden={ghost ? "true" : undefined}
      role={ghost ? undefined : "img"}
    >
      {!ghost && <title>{product.name} cross-section</title>}
      {product.draw()}
    </svg>
  );
}
